import { cn } from '@/lib/utils';
import { useAuth } from '@/store/auth';
import { effectiveProductSurface, getProductSurface } from '@/lib/product';

export function BrandLogo({
  compact = false,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  const features = useAuth((state) => state.features);
  const surface = effectiveProductSurface(getProductSurface(), features);
  const product = surface === 'lab' ? null : surface;
  const name = product ? (compact ? `${product}-mark` : `${product}-wordmark`) : compact ? 'mark' : 'wordmark-standard';
  return (
    <span className={cn('inline-flex shrink-0 items-center', className)} aria-label={product ? `Itsappy ${product === 'chat' ? 'Chat' : 'Meet'}` : 'Appy Lab'}>
      {product ? (
        <>
          <img src={`/brand/${name}-light.png?v=4`} alt="" className="h-full w-full object-contain object-left dark:hidden" />
          <img src={`/brand/${name}-dark.png?v=4`} alt="" className="hidden h-full w-full object-contain object-left dark:block" />
        </>
      ) : (
        <>
          <img src={`/brand/${name}-dark.png`} alt="" className="h-full w-full object-contain dark:hidden" />
          <img src={`/brand/${name}-light.png`} alt="" className="hidden h-full w-full object-contain dark:block" />
        </>
      )}
    </span>
  );
}
